import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/img/shopYell.png'


const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-5 gap-6" }
const _hoisted_2 = { class: "col-span-1 md:col-span-3" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "mr-3",
  style: {"width":"80px","height":"80px"}
}, null, -1)
const _hoisted_5 = { class: "font-bold text-lg" }
const _hoisted_6 = { class: "color-blue-grey text-base" }
const _hoisted_7 = /*#__PURE__*/_createVNode("hr", {
  class: "background-grey-lighten-4 my-5",
  style: {"height":"2px"}
}, null, -1)
const _hoisted_8 = { class: "mb-5" }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "Alamat Lengkap", -1)
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = { class: "col-span-1 md:col-span-2" }
const _hoisted_12 = {
  class: "",
  id: "printQrProfileAgent"
}
const _hoisted_13 = { class: "flex w-full justify-center mb-5" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "px-3 mb-5" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey text-center" }, "Kurir dapat melakukan scan barcode di atas untuk melanjutkan proses pendaftaran")
], -1)
const _hoisted_15 = { class: "flex justify-center" }
const _hoisted_16 = { class: "flex cursor-pointer background-red gap-2 px-4 py-2 rounded-lg" }
const _hoisted_17 = /*#__PURE__*/_createVNode("p", { class: "text-white font-semibold" }, "Print Barcode", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")
  const _directive_print = _resolveDirective("print")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Card, null, {
          title: _withCtx(() => [
            _createVNode("div", null, [
              _createVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode("div", null, [
                  _createVNode("p", _hoisted_5, _toDisplayString($setup.dataAgent?.Name), 1),
                  _createVNode("p", _hoisted_6, _toDisplayString($setup.dataAgent?.Code), 1)
                ])
              ]),
              _hoisted_7
            ])
          ]),
          content: _withCtx(() => [
            _createVNode("div", null, [
              _createVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode("p", _hoisted_10, _toDisplayString($setup.dataAgent?.Address), 1)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode(_component_Card, null, {
          content: _withCtx(() => [
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                ($setup.valueQR)
                  ? (_openBlock(), _createBlock(_component_qrcode_vue, {
                      key: 0,
                      value: $setup.valueQR,
                      level: "H",
                      size: 300,
                      "render-as": "svg"
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_14,
              _createVNode("div", _hoisted_15, [
                _withDirectives(_createVNode("div", _hoisted_16, [
                  _hoisted_17
                ], 512), [
                  [_directive_print, $setup.printWQr()]
                ])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}